import React, { Component } from 'react'
import { Route, Routes } from 'react-router-dom'

import HomePage from './Pages/HomePage'
import NewMerchant from './Pages/NewMerchant'
import NoMatch from './Pages/NoMatch'
import MerchantEditPage from './Pages/EditPages/MerchantEditPage'
import MerchantDetailsPage from './Pages/MerchantDetailsPage'
import PendingAgreements from './Pages/PendingAgreements'
import LegalAgreements from './Pages/LegalAgreements'
import LocationEditPage from './Pages/EditPages/LocationEditPage'
import ProfileEditPage from './Pages/EditPages/ProfileEditPage'
import RecoverPassword from './Pages/RecoverPassword'
import ConfirmEmail from './Pages/ConfirmEmail'
import ResetPassword from './Pages/ResetPassword'
import AddLocations from './Pages/MerchantOnboarding/AddLocations'
import LoginForm from './Pages/LoginForm'
import SignupForm from './Pages/SignupForm'
import RedirectBanner from './Pages/RedirectBanner'
import styles from './Styles/stylesDesktop'
import withNavigation from './withNavigation'
import { buildTimestamp, buildCommit, formatBuildLabel, hasBuildInfo } from './Constants/buildInfo'
import packageJson from "../package.json";
import { Provider, ErrorBoundary } from '@rollbar/react';

const buildInfo = { timestamp: buildTimestamp, commit: buildCommit }

class App extends Component {
  state = { showBuildInfo: false }

  // No-op when the build did not inject any metadata (e.g. the dev server).
  toggleBuildInfo = () => {
    if (!hasBuildInfo(buildInfo)) {
      return
    }

    this.setState((state) => ({ showBuildInfo: !state.showBuildInfo }))
  }

  render() {
    // Conditional to display the redirect banner on heroku environments
    if ((window.location.host.includes("herokuapp.com"))){
      return <RedirectBanner />
    }

    const { isAuthenticated } = this.props.auth
    const { pathname } = this.props.location
    const rollbarConfig = {
      accessToken: `${process.env.ROLLBAR_ACCESS_TOKEN}`,
      environment: `${process.env.ROLLBAR_ENVIRONMENT}`,
    }

    return (
      <Provider config={rollbarConfig}>
        <ErrorBoundary>
          <><div style={{ textAlign: 'center' }}>
            <header style={styles.appHeader}>
              {!isAuthenticated(pathname) && (
                <>
                  <Routes>
                    <Route path="/" element={<LoginForm auth={this.props.auth} />} />
                    <Route path="/sign-up" element={<SignupForm auth={this.props.auth} />} />
                    <Route path="/confirm-email/:query" element={<ConfirmEmail />} />
                    <Route path="/password-recovery" element={<RecoverPassword />} />
                    <Route path="/reset-password/:query" element={<ResetPassword />} />
                    <Route path="*" element={<NoMatch />} />
                  </Routes>
                </>
              )}
              {isAuthenticated(pathname) && (
                <>
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/pending-agreements" element={<PendingAgreements auth={this.props.auth} />} />
                    <Route path="/legal-agreements" element={<LegalAgreements />} />
                    <Route path="/new-merchant" element={<NewMerchant auth={this.props.auth} />} />
                    <Route path="/merchant/:id" element={<MerchantDetailsPage auth={this.props.auth} />} />
                    <Route path="/edit-merchant/:id" element={<MerchantEditPage />} />
                    <Route path="/edit-location/:id" element={<LocationEditPage />} />
                    <Route path="/add-location" element={<AddLocations />} />
                    <Route path="/user-profile" element={<ProfileEditPage />} />
                    <Route path="*" element={<NoMatch />} />
                  </Routes>
                </>
              )}
            </header>
          </div><div
            style={{ ...styles.appFooter, cursor: hasBuildInfo(buildInfo) ? 'pointer' : 'default' }}
            onClick={this.toggleBuildInfo}
            title={hasBuildInfo(buildInfo) ? 'Click to toggle build details' : undefined}>
            {formatBuildLabel(packageJson.version, buildInfo, this.state.showBuildInfo)}
          </div></>
        </ErrorBoundary>
      </Provider>
    )
  }
}

// withNavigation supplies `location`, so App re-renders on navigation and switches
// between the signed-in and signed-out route sets.
export default withNavigation(App)
